import React, { useEffect, useState } from "react";
import {
    getProcessRequest,
    createProcessRequest,
    updateProcessRequest,
    deleteProcessRequest
} from "../../globalhelper/helper";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";
import {
    Paper,
    Grid,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    IconButton
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ThemeList = () => {

    const history = useHistory();

    const [selectedProcessCd, setSelectedProcessCd] =
        useState(history.location.state?.selectedProcessCd || "");

    const [processCodes, setProcessCodes] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [hasSearched, setHasSearched] =
        useState(false);

    const [tableData, setTableData] =
        useState([]);

    const [originalRow, setOriginalRow] =
        useState(null);

    const [page, setPage] =
        useState(0);

    const [rowsPerPage, setRowsPerPage] =
        useState(10);

    const [isAdding, setIsAdding] =
        useState(false);

    const [newRow, setNewRow] =
        useState({});

    const [editRowId, setEditRowId] =
        useState(null);

    const [editedRow, setEditedRow] =
        useState({});

    const [deleteOpen, setDeleteOpen] =
        useState(false);

    const [deleteRow, setDeleteRow] =
        useState(null);

const [selectedProductCode, setSelectedProductCode] = useState("");
// const [selectedProcessCd, setselectedProcessCd] = useState("");
const [selectedThemeName, setSelectedThemeName] = useState(history.location.state?.selectedThemeName || "");

const [productCodes, setProductCodes] = useState([]);
// const [processCodes, setProcessCodes] = useState([]);
const [themeNames, setThemeNames] = useState([]);

const [showTable, setShowTable] = useState(false);

const getProductCodeList = async () => {

    try {

        const result = await getProcessRequest(
            "api/theme/getProductCodeList"
        );

        console.log(result.data);

        setProductCodes(result.data.data || []);

    } catch (err) {

        console.log(err);

    }

};

const getProcessCodeList = async (productCode) => {

    const result = await getProcessRequest(
        `api/theme/getProcessCodeList?productcode=${productCode}`
    );

    setProcessCodes(result?.data?.data || []);
};

const getThemeNameList = async (productCode, processCode) => {

    const result = await getProcessRequest(
        `api/theme/getThemeNameList?productcode=${productCode}&processcode=${processCode}`
    );

    setThemeNames(result?.data?.data || []);
};

    const getThemeProcessList = async () => {

        try {

            const result = await getProcessRequest(
                "api/theme/getThemeProcessList"
            );

            const data = result?.data?.data || [];

            setProcessCodes(data);   // or setThemeProcessList(data)

        } catch (error) {

            console.log("ERROR:", error);

        }
    };


    const getThemeByProcess = async (processCd) => {

        try {

            setLoading(true);

            const result = await getProcessRequest(
                `api/theme/getThemeByProcess/${processCd}`
            );

            const data = result?.data?.data || [];

            setTableData(data);
            setPage(0);
            setHasSearched(true);
            setShowTable(true);

            if (data.length > 0) {
                const prodCd = data[0].productcode;
                setSelectedProductCode(prodCd);
                await getProcessCodeList(prodCd);
                await getThemeNameList(prodCd, processCd);
            }

        } catch (error) {

            console.log("ERROR:", error);

        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {

        // getThemeProcessList();
        getProductCodeList();

        if (history.location.state?.selectedProcessCd) {

            getThemeByProcess(
                history.location.state.selectedProcessCd
            );

        }

    }, []);


    const paginatedData = tableData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleChangePage = (
        event,
        newPage
    ) => {

        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event
    ) => {

        setRowsPerPage(
            parseInt(
                event.target.value,
                10
            )
        );

        setPage(0);
    };

    const handleEdit = (row) => {

        setEditRowId(
            `${row.processcode}_${row.targetfieldname}`
        );

        setOriginalRow({
            processcode: row.processcode,
            targetfieldname: row.targetfieldname
        });

        setEditedRow({
            ...row
        });

    };

    const handleCancel = () => {
        setEditRowId(null);
        setEditedRow({});
    };

    const handleFieldChange = (
        field,
        value
    ) => {

        setEditedRow((prev) => {

            const updatedRow = {
                ...prev,
                [field]: value
            };

            if (
                field === "short_text" ||
                field === "process_cd"
            ) {

                const processCd =
                    field === "process_cd"
                        ? value.trim()
                        : updatedRow.process_cd?.trim();

                const shortText =
                    field === "short_text"
                        ? value.trim()
                        : updatedRow.short_text?.trim();

                updatedRow.domain =
                    shortText || "";

                // GENERATED VALUE
                const generatedValue =
                    processCd && shortText
                        ? `${processCd}_${shortText}`
                        : "";

                updatedRow.name = generatedValue;
                updatedRow.label = generatedValue;
                updatedRow.acronym = generatedValue;
            }

            return updatedRow;
        });
    };


    const handleSave = async (row) => {

        try {

            const duplicateExists = tableData.some((item) => {

                const isCurrentRow =

                    item.processcode === originalRow.processcode &&
                    item.targetfieldname === originalRow.targetfieldname;

                if (isCurrentRow) {
                    return false;
                }

                return (

                    item.productcode === row.productcode &&
                    item.processcode === row.processcode &&
                    item.targetfieldname?.toLowerCase().trim() ===
                    row.targetfieldname?.toLowerCase().trim()

                );

            });

            if (duplicateExists) {

                alert(
                    "Target Field Name already exists for this Process Code"
                );

                return;
            }

            const result =
                await updateProcessRequest(

                    `api/theme/updateTheme/${originalRow.processcode}/${originalRow.targetfieldname}`,

                    row

                );

            console.log(
                "UPDATED:",
                result
            );

            setTableData((prev) =>

                prev.map((item) =>

                    item.processcode === originalRow.processcode &&
                        item.targetfieldname === originalRow.targetfieldname

                        ? row
                        : item

                )

            );

            setEditRowId(null);
            setEditedRow({});
            setOriginalRow(null);

        } catch (error) {

            console.log(error);

            alert(
                error?.response?.data?.message ||
                "Update Failed"
            );

        }

    };

//     const getTheme = async () => {

//     const result = await getProcessRequest(
//         `api/theme/getTheme?productcode=${selectedProductCode}&processcode=${selectedProcessCd}&themename=${selectedThemeName}`
//     );

//     setTableData(result.data.data);
//     setHasSearched(true);
// };

    const handleSearch = async () => {

    if (
        !selectedProductCode ||
        !selectedProcessCd ||
        !selectedThemeName
    ) {
        toast.error("Please select all fields");
        return;
    }

    setShowTable(true);

    getThemeByProcess(selectedProcessCd);

};


    const handleDelete = async () => {

        if (!deleteRow) return;

        try {

            console.log(
                "DELETE API:",
                deleteRow
            );

            await deleteProcessRequest(

                `api/theme/deleteTheme/${deleteRow.processcode}/${deleteRow.targetfieldname}`

            );

            const filtered =
                tableData.filter(
                    (item) =>
                        !(
                            item.processcode === deleteRow.processcode &&
                            item.targetfieldname === deleteRow.targetfieldname
                        )
                );

            setTableData(filtered);

            toast.success(
                "Theme Deleted Successfully"
            );

        } catch (error) {

            console.log(error);

            toast.error(
                "Delete Failed"
            );

        } finally {

            setDeleteOpen(false);

            setDeleteRow(null);
        }
    };

    const handleAddRow = () => {

        const selectedProcess =
            processCodes.find(
                (item) =>
                    item.processcode ===
                    selectedProcessCd
            );

        setNewRow({

            productcode:
                selectedProcess?.productcode || "DTFOWS",

            processcode:
                selectedProcessCd,

            themename:
                selectedProcess?.themename || "",

            targetfieldname: "",

            createddate: "",

            targetfielddatatype: "",

            lde: "",

            sourcefieldname: "",

            mandatory: "",

            sourcefieldfunction: "",

            dataformat: "",

            scdp: false

        });

        setIsAdding(true);
    };

    const handleNewRowChange = (
        field,
        value
    ) => {

        setNewRow((prev) => ({

            ...prev,

            [field]: value

        }));

    };
    const handleSaveNewRow = async () => {

        if (!newRow.targetfieldname?.trim()) {

            toast.error(
                "Target Field Name is required"
            );

            return;
        }

        try {

            console.log(
                "NEW ROW:",
                newRow
            );

            const result =
                await createProcessRequest(
                    "api/theme/createTheme",
                    newRow
                );

            console.log(
                "CREATED:",
                result
            );

            if (result.type === "failed") {

                toast.error(
                    result?.data?.message ||
                    "Failed to create Theme"
                );

                return;
            }

            if (result.type === "success") {

                setTableData((prev) => [
                    ...prev,
                    result.data.data
                ]);

                toast.success(
                    result.data.message ||
                    "Theme Created Successfully"
                );

                setIsAdding(false);

                setNewRow({});
            }

        } catch (error) {

            console.log(error);

            toast.error(
                error?.response?.data?.message ||
                "Failed to create Theme"
            );

        }
    };

    const handleCancelNewRow = () => {

        setIsAdding(false);

        setNewRow({});

    };

    return (

        <Paper
            elevation={3}
            sx={{
                padding: "25px",
                margin: "20px"
            }}
        >

            {/* HEADER */}

 <Grid
    container
    justifyContent="space-between"
    alignItems="center"
    sx={{
        marginBottom: "25px"
    }}
>

    <Grid item sx={{ display: "flex", gap: "8px", alignItems: "center" }}>

        <IconButton
            onClick={() => history.push("/transactionlog")}
            color="primary"
        >
            <ArrowBackIcon />
        </IconButton>

        <Typography variant="h5">
            Theme Management
        </Typography>

    </Grid>

    <Grid item>

        <Button
            variant="contained"
            onClick={() => history.push("/theme/create")}
        >
            + Create New Theme
        </Button>

    </Grid>

</Grid>

            {/* FILTER */}

<Paper
    elevation={2}
    sx={{
        padding: "20px",
        marginBottom: "25px"
    }}
>

    <Grid container spacing={3}>

        {/* PRODUCT CODE */}

        <Grid item xs={12} md={3}>

            <FormControl fullWidth>

                <InputLabel>
                    Product Code
                </InputLabel>

                <Select
                    value={selectedProductCode}
                    label="Product Code"
                    onChange={async (e) => {

                        const value = e.target.value;

                        setSelectedProductCode(value);

                        setSelectedProcessCd("");
                        setSelectedThemeName("");

                        setProcessCodes([]);
                        setThemeNames([]);

                        await getProcessCodeList(value);

                    }}
                >

                    {productCodes.map((item) => (

                        <MenuItem
                            key={item.productcode}
                            value={item.productcode}
                        >
                            {item.productcode}
                        </MenuItem>

                    ))}

                </Select>

            </FormControl>

        </Grid>

        {/* PROCESS CODE */}

        <Grid item xs={12} md={3}>

            <FormControl fullWidth>

                <InputLabel>
                    Process Code
                </InputLabel>

                <Select
                    value={selectedProcessCd}
                    label="Process Code"
onChange={async (e) => {

    const value = e.target.value;

    setSelectedProcessCd(value);

    setSelectedThemeName("");

    setThemeNames([]);

    await getThemeNameList(
        selectedProductCode,
        value
    );

}}
                >

                    {processCodes.map((item) => (

                        <MenuItem
                            key={item.processcode}
                            value={item.processcode}
                        >
                            {item.processcode}
                        </MenuItem>

                    ))}

                </Select>

            </FormControl>

        </Grid>

        {/* THEME NAME */}

        <Grid item xs={12} md={3}>

            <FormControl fullWidth>

                <InputLabel>
                    Theme Name
                </InputLabel>

                <Select
                    value={selectedThemeName}
                    label="Theme Name"
                    onChange={(e) =>
                        setSelectedThemeName(e.target.value)
                    }
                >

                    {themeNames.map((item) => (

                        <MenuItem
                            key={item.themename}
                            value={item.themename}
                        >
                            {item.themename}
                        </MenuItem>

                    ))}

                </Select>

            </FormControl>

        </Grid>

        {/* SEARCH */}

        <Grid item xs={12} md={3}>

            <Button
                fullWidth
                variant="contained"
                sx={{ height: "56px" }}
                disabled={
                    !selectedProductCode ||
                    !selectedProcessCd ||
                    !selectedThemeName ||
                    loading
                }
                onClick={handleSearch}
            >
                {loading ? "Searching..." : "Search"}
            </Button>

        </Grid>

    </Grid>

</Paper>

            {/* TABLE */}
            {showTable && (

            <Paper elevation={2}>

                <div
                    style={{
                        width: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "600px"
                    }}
                >

                    <TableContainer>

                        <Table
                            stickyHeader
                            sx={{
                                minWidth: "1600px"
                            }}
                        >

<TableHead>

    <TableRow>

        <TableCell>
            Product Code
        </TableCell>

        <TableCell>
            Process Code
        </TableCell>

        <TableCell>
            Theme Name
        </TableCell>

        <TableCell>
            Target Field Name
        </TableCell>

        <TableCell>
            Target Field Data Type
        </TableCell>

        <TableCell>
            LDE
        </TableCell>

        <TableCell>
            Source Field Name
        </TableCell>

        <TableCell>
            Mandatory
        </TableCell>

        <TableCell>
            Source Field Function
        </TableCell>

        <TableCell>
            Data Format
        </TableCell>

        <TableCell>
            SCDP
        </TableCell>

        <TableCell>
            Action
        </TableCell>

    </TableRow>

</TableHead>

                            <TableBody>

                                {!selectedProcessCd ? (

                                    <TableRow>

                                        <TableCell
                                            colSpan={12}
                                            align="center"
                                        >
                                            Please Select Process Code
                                        </TableCell>

                                    </TableRow>

                                ) : loading ? (

                                    <TableRow>

                                        <TableCell
                                            colSpan={12}
                                            align="center"
                                        >
                                            Fetching Theme Data...
                                        </TableCell>

                                    </TableRow>

                                ) : (

                                    <>

                                        {paginatedData.length > 0 ? (

                                            paginatedData.map((row) => {

                                                const isEditing =
                                                    editRowId ===
                                                    `${row.processcode}_${row.targetfieldname}`;

                                                return (

                                                    <TableRow
                                                        key={`${row.processcode}_${row.targetfieldname}`}
                                                    >

{/* PRODUCT CODE */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.productcode ??
                row.productcode
            }
            onChange={(e) =>
                handleFieldChange(
                    "productcode",
                    e.target.value
                )
            }
        />

    ) : (

        row.productcode

    )}

</TableCell>

{/* PROCESS CODE */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.processcode ??
                row.processcode
            }
            onChange={(e) =>
                handleFieldChange(
                    "processcode",
                    e.target.value
                )
            }
        />

    ) : (

        row.processcode

    )}

</TableCell>

{/* THEME NAME */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.themename ??
                row.themename
            }
            onChange={(e) =>
                handleFieldChange(
                    "themename",
                    e.target.value
                )
            }
        />

    ) : (

        row.themename

    )}

</TableCell>


{/* TARGET FIELD NAME */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.targetfieldname ??
                row.targetfieldname
            }
            error={
                !(editedRow.targetfieldname ?? row.targetfieldname)?.trim()
            }
            helperText={
                !(editedRow.targetfieldname ?? row.targetfieldname)?.trim()
                    ? "Target Field Name is required"
                    : ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "targetfieldname",
                    e.target.value
                )
            }
        />

    ) : (

        row.targetfieldname

    )}

</TableCell>

{/* TARGET FIELD DATA TYPE */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.targetfielddatatype ??
                row.targetfielddatatype
            }
            onChange={(e) =>
                handleFieldChange(
                    "targetfielddatatype",
                    e.target.value
                )
            }
        />

    ) : (

        row.targetfielddatatype

    )}

</TableCell>

{/* LDE */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.lde ??
                row.lde ??
                ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "lde",
                    e.target.value
                )
            }
        />

    ) : (

        row.lde

    )}

</TableCell>

{/* SOURCE FIELD NAME */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.sourcefieldname ??
                row.sourcefieldname ??
                ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "sourcefieldname",
                    e.target.value
                )
            }
        />

    ) : (

        row.sourcefieldname

    )}

</TableCell>

{/* MANDATORY */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.mandatory ??
                row.mandatory ??
                ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "mandatory",
                    e.target.value
                )
            }
        />

    ) : (

        row.mandatory

    )}

</TableCell>

{/* SOURCE FIELD FUNCTION */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.sourcefieldfunction ??
                row.sourcefieldfunction ??
                ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "sourcefieldfunction",
                    e.target.value
                )
            }
        />

    ) : (

        row.sourcefieldfunction

    )}

</TableCell>

{/* DATA FORMAT */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.dataformat ??
                row.dataformat ??
                ""
            }
            onChange={(e) =>
                handleFieldChange(
                    "dataformat",
                    e.target.value
                )
            }
        />

    ) : (

        row.dataformat

    )}

</TableCell>

{/* SCDP */}

<TableCell>

    {isEditing ? (

        <TextField
            size="small"
            value={
                editedRow.scdp ?? row.scdp
            }
            onChange={(e) =>
                handleFieldChange(
                    "scdp",
                    e.target.value
                )
            }
        />

    ) : (

        String(row.scdp)

    )}

</TableCell>

                                                        {/* ACTION */}

                                                        <TableCell>

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    gap: "5px"
                                                                }}
                                                            >

                                                                {isEditing ? (

                                                                    <>

                                                                        <IconButton
                                                                            color="success"
                                                                            onClick={() =>
                                                                                handleSave({
                                                                                    ...row,
                                                                                    ...editedRow
                                                                                })
                                                                            }
                                                                        >
                                                                            <SaveIcon />
                                                                        </IconButton>

                                                                        <IconButton
                                                                            color="secondary"
                                                                            onClick={
                                                                                handleCancel
                                                                            }
                                                                        >
                                                                            <CloseIcon />
                                                                        </IconButton>

                                                                    </>

                                                                ) : (

                                                                    <>

                                                                        <IconButton
                                                                            color="primary"
                                                                            onClick={() =>
                                                                                handleEdit(row)
                                                                            }
                                                                        >
                                                                            <EditIcon />
                                                                        </IconButton>

                                                                        <IconButton
                                                                            color="error"
                                                                            onClick={() => {
                                                                                setDeleteRow(row);
                                                                                setDeleteOpen(true);
                                                                            }}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>

                                                                    </>

                                                                )}

                                                            </div>

                                                        </TableCell>

                                                    </TableRow>

                                                );
                                            })

) : hasSearched ? (

    <TableRow>

        <TableCell
            colSpan={12}
            align="center"
        >
            No Records Found
        </TableCell>

    </TableRow>

) : null}

{/* ========================= */}
{/* ADD NEW ROW */}
{/* ========================= */}

{isAdding && (

    <TableRow>

        <TableCell>
            {newRow.productcode}
        </TableCell>

        <TableCell>
            {newRow.processcode}
        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.themename}
                onChange={(e) =>
                    handleNewRowChange(
                        "themename",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                required
                size="small"
                value={newRow.targetfieldname}
                error={!newRow.targetfieldname?.trim()}
                helperText={
                    !newRow.targetfieldname?.trim()
                        ? "Target Field Name is required"
                        : ""
                }
                onChange={(e) =>
                    handleNewRowChange(
                        "targetfieldname",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.targetfielddatatype}
                onChange={(e) =>
                    handleNewRowChange(
                        "targetfielddatatype",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.lde}
                onChange={(e) =>
                    handleNewRowChange(
                        "lde",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.sourcefieldname}
                onChange={(e) =>
                    handleNewRowChange(
                        "sourcefieldname",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.mandatory}
                onChange={(e) =>
                    handleNewRowChange(
                        "mandatory",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.sourcefieldfunction}
                onChange={(e) =>
                    handleNewRowChange(
                        "sourcefieldfunction",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={newRow.dataformat}
                onChange={(e) =>
                    handleNewRowChange(
                        "dataformat",
                        e.target.value
                    )
                }
            />

        </TableCell>

        <TableCell>

            <TextField
                size="small"
                value={String(newRow.scdp)}
                onChange={(e) =>
                    handleNewRowChange(
                        "scdp",
                        e.target.value === "true"
                    )
                }
            />

        </TableCell>

        <TableCell>

            <div
                style={{
                    display: "flex",
                    gap: "5px"
                }}
            >

                <IconButton
                    color="success"
                    onClick={handleSaveNewRow}
                >
                    <SaveIcon />
                </IconButton>

                <IconButton
                    color="secondary"
                    onClick={handleCancelNewRow}
                >
                    <CloseIcon />
                </IconButton>

            </div>

        </TableCell>

    </TableRow>

)}

                                    </>

                                )}

                            </TableBody>

                        </Table>

                    </TableContainer>

                    <div
                        style={{
                            padding: "15px",
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >

                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            disabled={
                                !selectedProcessCd ||
                                isAdding
                            }
                            onClick={handleAddRow}
                        >
                            Add Row
                        </Button>

                    </div>

                    {/* PAGINATION */}

                    {tableData.length > 0 && (

                        <TablePagination
                            component="div"
                            count={tableData.length}
                            page={page}
                            onPageChange={
                                handleChangePage
                            }
                            rowsPerPage={
                                rowsPerPage
                            }
                            onRowsPerPageChange={
                                handleChangeRowsPerPage
                            }
                            rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                50
                            ]}
                        />

                    )}

                </div>

                <Dialog
                    open={deleteOpen}
                    onClose={() =>
                        setDeleteOpen(false)
                    }
                    PaperProps={{
                        sx: {
                            width: "420px",
                            borderRadius: "18px",
                            padding: "10px"
                        }
                    }}
                >

                    <DialogTitle
                        sx={{
                            fontSize: "30px",
                            fontWeight: 600,
                            paddingBottom: "10px"
                        }}
                    >
                        Confirm Delete
                    </DialogTitle>

                    <DialogContent
                        sx={{
                            paddingTop: "0px !important"
                        }}
                    >

                        <DialogContentText
                            sx={{
                                fontSize: "16px"
                            }}
                        >
                            Are you sure you want to delete

                            <b>
                                {" "}
                                {deleteRow?.targetfieldname}
                            </b>
                            ?

                        </DialogContentText>

                    </DialogContent>

                    <DialogActions
                        sx={{
                            padding: "18px 24px 20px"
                        }}
                    >

                        <Button
                            onClick={() =>
                                setDeleteOpen(false)
                            }
                            sx={{
                                textTransform: "none"
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            color="error"
                            variant="contained"
                            onClick={handleDelete}
                            sx={{
                                borderRadius: "10px",
                                textTransform: "none",
                                padding: "8px 22px"
                            }}
                        >
                            Delete
                        </Button>

                    </DialogActions>

                </Dialog>

            </Paper>
            )}
        </Paper>
    );
};

export default ThemeList;